



































































































































































import { Component, Mixins, Watch, Ref, Prop } from "vue-property-decorator";

import BaseDropdown from "@/components/BaseDropdown/BaseDropdown.vue";
import InputRow from "@/components/InputRow/InputRow.vue";
import TextField from "@/components/TextField/TextField.vue";
import AsyncButton from "@/components/BaseAsyncButton/BaseAsyncButton.vue";
import Spinner from "@/components/BaseSpinner/BaseSpinner.vue";
import Alert from "@/components/BaseAlert/BaseAlert.vue";

import RequestState from "@/utils/mixins/RequestState";

import { Action, State } from "vuex-class";
import { IVuexState } from "@/models/interfaces/store";
import { ISchool } from "@/models/interfaces/schools";
import { IClass } from "@/models/interfaces/classes";
import { IStudentPayload, IStudent } from "@/models/interfaces/students";
import { AxiosResponse } from "axios";
import { ValidationObserver, ValidationProvider } from "vee-validate";

@Component({
  components: {
    BaseDropdown,
    InputRow,
    TextField,
    AsyncButton,
    Spinner,
    Alert,

    ValidationObserver,
    ValidationProvider
  }
})
export default class StudentsAddView extends Mixins(RequestState) {
  @Prop({ type: Object })
  private initialData!: IStudent;

  @State("schools", { namespace: "schools" })
  private schools!: IVuexState<ISchool[]>;

  @State("classes", { namespace: "classes" })
  private classes!: IVuexState<IClass[]>;

  @Action("students/generateUsername")
  private generateUsername!: (params: {
    firstname: string;
    lastname: string;
  }) => Promise<AxiosResponse>;

  @Action("schools/fetchSchools")
  private fetchSchools!: () => Promise<{ schools: ISchool[] }>;

  @Action("classes/fetchClassesForSchool")
  private fetchClassesForSchool!: (
    schoolsIds: string[]
  ) => Promise<{ classes: IClass[] }>;

  private isSubmitting = false;
  private isGeneratingUsername = false;

  private schoolId = "";
  private initialClassId = "";

  private form: IStudentPayload | {} = {};

  private get isEditMode() {
    return this.$route.fullPath.includes("edit");
  }

  private get schoolsOptions() {
    return this.schools.data?.map(({ schoolName, schoolId }) => ({
      label: schoolName,
      value: schoolId
    }));
  }

  private get classesOptions() {
    return this.schoolId && !this.isEmpty(this.classes)
      ? this.classes.data!.map(item => ({
          label: item.className,
          value: item.classId
        }))
      : [];
  }

  private get passwordRules() {
    if (this.isEditMode) {
      const form = this.form as IStudentPayload;
      return form.password ? "min:6" : "";
    } else {
      return "required|min:6";
    }
  }

  private setLoadingState(state: boolean) {
    this.isSubmitting = state;
  }

  private async onGenerateUsername() {
    if (this.isEditMode) {
      // TODO: Remove this condition as soon as API is done
      this.$emit("on-popup-toggle", "Unable to edit student's username");
      return;
    }

    const { firstname, lastname } = this.form as IStudentPayload;

    if (!firstname || !lastname) {
      this.$emit(
        "on-popup-toggle",
        "Please fill student's first and last names."
      );
      return;
    }

    this.isGeneratingUsername = true;

    this.generateUsername({
      firstname,
      lastname
    })
      .then(({ data }) => {
        (this.form as IStudentPayload).username = data.username;
      })
      .catch(() => {
        this.$emit(
          "on-popup-toggle",
          "The user name generation has failed. Try again later."
        );
      })
      .finally(() => {
        this.isGeneratingUsername = false;
      });
  }

  private submit(validateForm, isFormValid) {
    if (this.isEditMode) {
      this.$emit("submit", this.form);
      return;
    }

    validateForm();
    if (isFormValid) {
      this.$emit("submit", this.form);
    }
  }

  public async mounted() {
    await this.fetchSchools();

    if (this.initialData) {
      const {
        username,
        firstname,
        lastname,
        schoolId,
        classId
      } = this.initialData;
      this.initialClassId = classId;
      this.schoolId = schoolId;

      this.form = Object.assign(this.form, {
        username,
        firstname,
        lastname
      });
    }
  }

  @Watch("schoolId")
  private async onSchoolSelected() {
    if (this.schoolId) {
      await this.fetchClassesForSchool([this.schoolId]);

      if (this.initialClassId) {
        this.form = Object.assign(this.form, {
          classId: this.initialClassId
        });
        this.initialClassId = "";
      }
    }
  }
}
